module.exports = __webpack_public_path__ + "static/img/11.8da7e9b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/zh/11.png
// module id = Z0RK
// module chunks = 0